






































import Vue from 'vue';
import { BButtonClose } from 'bootstrap-vue';
import { findIndex, has } from 'lodash';

import * as allCardComponents from './allCardComponents';
import { ModalSize } from './types';

const BODY_CLASS = 'modal-open';

export default Vue.extend({
  name: 'ZenModalWrapper',
  components: {
    BButtonClose,
    ...allCardComponents,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
    cacheTypes: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String as () => ModalSize,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    currentContext(): any[] {
      let context;

      if (typeof this.modal.context === 'boolean') {
        context = window.GGRC.zenModalContext;
      } else if (typeof this.modal.context === 'string') {
        context = window.GGRC.zenModalContext[this.modal.context];
      }

      return context || [this.modal.data];
    },
    currentData(): object {
      return this.currentContext[this.currentIndex];
    },
    canGoLeft(): boolean {
      return this.currentIndex > 0;
    },
    canGoRight(): boolean {
      return this.currentIndex < this.currentContext.length - 1;
    },
    dialogClass(): Array<string | object> {
      return [
        'modal-dialog',
        { 'modal-sm': this.size === ModalSize.Small },
        { 'modal-lg': this.size === ModalSize.Large },
      ];
    },
    isTypeNewObjectPage(): boolean {
      return this.modal.type === 'NewObjectPage';
    },
  },
  watch: {
    modal: {
      handler() {
        // For some cases (like Service Now) modal.data
        // cotains more properties than expected, we need to remove
        // it in order to find the correct index.
        // TODO: this will be removed/fixed when we go live with
        // the new ticketing integration:
        // https://reciprocitylabs.atlassian.net/browse/ZEN-13558
        if (has(this.modal.data, 'olHasClickHandler')) {
          delete this.modal.data.olHasClickHandler;
        }

        const index = findIndex(this.currentContext, this.modal.data);
        if (index === -1) {
          // TODO: TEMP throw error instead
          // eslint-disable-next-line no-console
          console.error("Didn't find item in context.");
        }
        this.currentIndex = index;
      },
      immediate: true,
    },
    currentIndex() {
      this.$emit('updateData', this.currentData, true);
      // Reset the previous configuration due to some edge cases, but keep
      // just the modal size.
      this.$emit('updateConfig', { size: this.modal.config.size }, true);
    },
  },
  mounted() {
    document.body.classList.add(BODY_CLASS);
    document.body.addEventListener('keydown', this.keyHandler);
  },
  destroyed() {
    document.body.classList.remove(BODY_CLASS);
    document.body.removeEventListener('keydown', this.keyHandler);
    // Fix Bootstrap tooltip bug that keeps it shown if this component is in a
    // modal and this one is closed
    const tooltipNode = document.querySelector('.info-tooltip');
    if (tooltipNode) {
      tooltipNode.remove();
    }
  },
  methods: {
    move(offset: number) {
      this.currentIndex += offset;
    },
    updateConfig(newValue: object, replace: boolean) {
      this.$emit('updateConfig', newValue, replace);
    },
    /* eslint-disable complexity */
    keyHandler(ev: KeyboardEvent) {
      // Only capture ESC, left, right arrow and
      // ignore if user is interacting with a form element
      if (
        ![27, 37, 39].includes(ev.keyCode) ||
        ['INPUT', 'SELECT'].includes(document.activeElement.tagName) ||
        document.activeElement.attributes.contenteditable
      ) {
        return;
      }

      ev.preventDefault();
      switch (ev.keyCode) {
        case 27:
          this.$emit('close');
          break;
        case 37:
          if (this.canGoLeft) {
            this.move(-1);
          }
          break;
        case 39:
          if (this.canGoRight) {
            this.move(1);
          }
          break;
      }
    },
    /* eslint-enable complexity */
  },
});
